import { Verse } from './types';

export const gratitudeVerses: Verse[] = [
  {
    text: "Give thanks to the Lord, for he is good; his love endures forever.",
    reference: "Psalm 107:1",
    why: "This verse reminds us to be thankful for God's enduring love and goodness."
  },
  {
    text: "Give thanks in all circumstances; for this is God's will for you in Christ Jesus.",
    reference: "1 Thessalonians 5:18",
    why: "This verse encourages us to be grateful in every situation as part of God's plan."
  },
  {
    text: "Let them give thanks to the Lord for his unfailing love and his wonderful deeds for mankind.",
    reference: "Psalm 107:8",
    why: "This verse calls us to recognize and give thanks for God's works and unfailing love."
  },
  {
    text: "Enter his gates with thanksgiving and his courts with praise; give thanks to him and praise his name.",
    reference: "Psalm 100:4",
    why: "This verse encourages us to approach God with a heart full of thanksgiving and praise."
  },
  {
    text: "I will give thanks to you, Lord, with all my heart; I will tell of all your wonderful deeds.",
    reference: "Psalm 9:1",
    why: "This verse reminds us to give thanks wholeheartedly and share God's works with others."
  },
  {
    text: "Let the peace of Christ rule in your hearts, since as members of one body you were called to peace. And be thankful.",
    reference: "Colossians 3:15",
    why: "This verse highlights the connection between peace in Christ and a grateful heart."
  },
  {
    text: "Thanks be to God for his indescribable gift!",
    reference: "2 Corinthians 9:15",
    why: "This verse acknowledges God's greatest gift and encourages us to express gratitude."
  },
  {
    text: "Devote yourselves to prayer, being watchful and thankful.",
    reference: "Colossians 4:2",
    why: "This verse encourages us to combine prayer with thankfulness in our daily lives."
  },
  {
    text: "Give thanks to the Lord, for he is good; his love endures forever.",
    reference: "Psalm 136:1",
    why: "This verse emphasizes God's enduring love as a reason for thankfulness."
  },
  {
    text: "I will praise God’s name in song and glorify him with thanksgiving.",
    reference: "Psalm 69:30",
    why: "This verse connects gratitude with worship and praise through song."
  },
  {
    text: "I always thank my God for you because of his grace given you in Christ Jesus.",
    reference: "1 Corinthians 1:4",
    why: "This verse teaches us to be thankful for the people in our lives and God's grace in them."
  },
  {
    text: "Let us come before him with thanksgiving and extol him with music and song.",
    reference: "Psalm 95:2",
    why: "This verse calls us to worship God with gratitude and joy."
  },
  {
    text: "Give thanks to the Lord, call on his name; make known among the nations what he has done.",
    reference: "1 Chronicles 16:8",
    why: "This verse reminds us to give thanks and share God's works with the world."
  },
  {
    text: "Let them sacrifice thank offerings and tell of his works with songs of joy.",
    reference: "Psalm 107:22",
    why: "This verse encourages us to express gratitude through joyful offerings and songs."
  },
  {
    text: "Give thanks to the God of heaven. His love endures forever.",
    reference: "Psalm 136:26",
    why: "This verse emphasizes God's eternal love and inspires gratitude."
  },
  {
    text: "Sing to the Lord with grateful praise; make music to our God on the harp.",
    reference: "Psalm 147:7",
    why: "This verse ties gratitude to musical worship and joyful praise."
  },
  {
    text: "Always giving thanks to God the Father for everything, in the name of our Lord Jesus Christ.",
    reference: "Ephesians 5:20",
    why: "This verse calls us to consistently give thanks for everything in Jesus' name."
  },
  {
    text: "I will give thanks to the Lord because of his righteousness; I will sing the praises of the name of the Lord Most High.",
    reference: "Psalm 7:17",
    why: "This verse reminds us to praise and thank God for His righteousness."
  },
  {
    text: "Shout for joy to the Lord, all the earth. Worship the Lord with gladness; come before him with joyful songs.",
    reference: "Psalm 100:1-2",
    why: "This verse calls us to approach God with joy and gratitude in worship."
  },
  {
    text: "Let us give thanks to the Lord for his unfailing love and his wonderful deeds for mankind.",
    reference: "Psalm 107:21",
    why: "This verse highlights God's love and actions as reasons for thankfulness."
  },
  {
    text: "But thanks be to God! He gives us the victory through our Lord Jesus Christ.",
    reference: "1 Corinthians 15:57",
    why: "This verse acknowledges God's role in our spiritual victory and inspires gratitude."
  },
  {
    text: "And whatever you do, whether in word or deed, do it all in the name of the Lord Jesus, giving thanks to God the Father through him.",
    reference: "Colossians 3:17",
    why: "This verse ties gratitude to every action we take in Jesus' name."
  },
  {
    text: "I thank my God every time I remember you.",
    reference: "Philippians 1:3",
    why: "This verse encourages us to express gratitude for the people in our lives."
  },
  {
    text: "Let us be thankful, and so worship God acceptably with reverence and awe.",
    reference: "Hebrews 12:28",
    why: "This verse connects gratitude with acceptable worship and reverence for God."
  },
  {
    text: "Give thanks to the Lord, for he is good; his steadfast love endures forever.",
    reference: "Psalm 118:29",
    why: "This verse encourages us to praise God for His goodness and unfailing love."
  }
];
